export const dashboardTabsConstants = {
    DEVICE: '#device',
    STORE_LOCATOR: '#store-locator',
    VUSE_WORLD: '#vuse-world',
    ACCOUNT: '#account',
    MENU: '#menu',
    POD_TRACKER: '#pod-tracker',
    POD_TRACKER_OPTIN: '#pod-tracker-optin',
    POD_TRACKER_OPTIN_INSTRUCTIONS: '#pod-tracker-optin-instructions'
}